// extracted by mini-css-extract-plugin
module.exports = {"modalGradient":"Modal_modalGradient__p2viz","modal":"Modal_modal__PoGhq","modalVideo":"Modal_modalVideo__Kxac1","button":"Modal_button__jV3l7"};